// common/config.js
import configDev from './config.dev.js';
import configProd from './config.prod.js';

const env = process.env.NODE_ENV || 'development';
const config = env === 'production' ? configProd : configDev;

export default config;